import { render, staticRenderFns } from "./small-report-test.vue?vue&type=template&id=f6c3f8e0&scoped=true&"
import script from "./small-report-test.vue?vue&type=script&lang=js&"
export * from "./small-report-test.vue?vue&type=script&lang=js&"
import style0 from "./small-report-test.vue?vue&type=style&index=0&id=f6c3f8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c3f8e0",
  null
  
)

export default component.exports